import React from 'react';
import Freshchat from "../Footer/Freshchat"



export default () => (
  <div>
    <Freshchat/>
  </div>
);
